<template>
    <b-button variant="warning" @click.stop="confirmar()" v-if="mostrarBtn">
        <i class="fa fa-exclamation-triangle mr-2"></i>Definir como
        {{ pagamento.prioritario ? 'não ' : '' }}prioriario
    </b-button>
</template>

<script>
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => {}
        },

        pagamentosServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmar() {
            this.$swal({
                title: 'Registro de Pagamento',
                html: `Confirma a ${
                    this.pagamento.prioritario ? 'não ' : ''
                }definição do registro de pagamento ${
                    this.pagamento.protocolo
                } como prioritário?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .definirPrioritario(this.pagamento.pagamentoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar registro de pagamento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {},

    computed: {
        mostrarBtn() {
            return (
                this.$temAcessoView('CONT-PAG-10') &&
                (this.pagamento.status == pagamentoStatus.EM_ANALISE ||
                    this.pagamento.status ==
                        pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO)
            )
        }
    },

    watch: {},

    validations: {}
}
</script>
